import { recordPath, recordRoute } from '@/shared/registry'

/** Where the survey pages live. */
export const surveysPath = '/catalog/surveys'
export const createSurveyPath = `${surveysPath}/new`
export const surveyRoute = recordRoute('catalog', 'surveys')
export const editSurveyRoute = `${surveyRoute}/edit`
export const designSurveyRoute = `${surveyRoute}/design`

/** A survey's details page. */
export function surveyPath(id: string): string {
  return recordPath('catalog', 'surveys', id)
}

/** A survey's designer. */
export function designSurveyPath(id: string): string {
  return `${surveyPath(id)}/design`
}

/**
 * The base of Survey Details' slots (`detailsSlots`): Launch puts Survey Responses and the exports
 * in its actions (LCH-22).
 */
export const surveyDetailsSlot = 'catalog.survey-details'

/** The API's survey endpoints. */
export const surveysApi = '/catalog/v1/surveys'

export function surveyApi(id: string): string {
  return `${surveysApi}/${encodeURIComponent(id)}`
}

export function surveyDesignApi(id: string): string {
  return `${surveyApi(id)}/design`
}

/** The surveys a course may name: by the saved course, or by the organization of a new one. */
export const surveyChoicesApi = `${surveysApi}/choices`

/** What each survey action needs; sharing with every organization needs write at every organization. */
export const readSurveysPermission = 'catalog.surveys.read'
export const writeSurveysPermission = 'catalog.surveys.write'
export const deleteSurveysPermission = 'catalog.surveys.delete'
